"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const each_1 = require("./each");
/**
 * Split an hash into chunks.
 *
 * @param {*} hash
 * @param {number} size
 * @param {boolean} preserveKeys
 * @returns {Array<Map<any, any>>}
 */
function chunk(hash, size, preserveKeys = false) {
    let result = [];
    let count = 0;
    let currentMap;
    each_1.each(hash, (key, value) => {
        if (!currentMap) {
            currentMap = new Map();
            result.push(currentMap);
        }
        currentMap.set(preserveKeys ? key : count, value);
        count++;
        if (count >= size) {
            count = 0;
            currentMap = null;
        }
    });
    return result;
}
exports.chunk = chunk;
